import * as React from 'react';

import { PageElementActionButton } from '../styles';
import { IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import Utils from '../../../utils';

interface VisibilityToggleProps {
	isVisible: boolean;
	isParentActive: boolean;
	pageScale: number;
	spreadZoom: number;
	onToggle: () => void;
	isAccessibleVersion: boolean;
}

const VisibilityToggle = ({
	isVisible,
	isParentActive,
	pageScale,
	spreadZoom,
	onToggle,
	isAccessibleVersion,
}: VisibilityToggleProps) => (
	<PageElementActionButton
		className={IGNORE_PAGE_CLICK_CLASSNAME}
		isActive={isParentActive}
		pageScale={pageScale}
		spreadZoom={spreadZoom}
		onClick={onToggle}
		isAccessibleVersion={isAccessibleVersion}
		isVisible={isVisible}
	>
		{Utils.getSvgIcon(isVisible ? 'iconset_uprez_eye' : 'iconset_uprez_eye_crossed')}
	</PageElementActionButton>
);

export default VisibilityToggle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/VisibilityToggle/index.tsx